/* @flow */

import React, { Component } from 'react';
import type { $BaseWidgetState } from '../../types/BaseWidgetState';
import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import renderTemplate from '../../utils/TemplateRenderer';
import Globals from '../../constants/Globals';
import { TemplateMarketPropertyKeys } from '../../templates/TemplateMarketProperties';
import { getConfigurationMarketProperty } from '../../utils/WidgetUtils';

type $Props = {
  widgetState: $BaseWidgetState,
  addressLineModifierClass?: string
};

export function getDealerBaseAddress(
  dealer: $Dealer, configuration: $Configuration, marketCode: string, defaultPlaceholders: Array<string>
): Array<string> {
  const dealerBaseAddress: Array<string> = [];

  const placeholderKeys = [
    TemplateMarketPropertyKeys.GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_1,
    TemplateMarketPropertyKeys.GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_2,
    TemplateMarketPropertyKeys.GEN_DEALER_ADDRESS_PLACEHOLDER_LINE_3
  ];

  for (let i = 0; i < placeholderKeys.length; i++) {
    const marketProperty = getConfigurationMarketProperty(configuration, marketCode, placeholderKeys[i]);

    let marketPropertyValue: string = '';

    if (marketProperty && marketProperty.template && Array.isArray(marketProperty.template)) {
      marketPropertyValue = marketProperty.template.join('');
    }
    else if (typeof marketProperty === 'string') marketPropertyValue = marketProperty;

    if (marketPropertyValue) {
      const addressLineValue = renderTemplate(`${ marketPropertyValue }`, dealer, false).trim();
      if (addressLineValue) dealerBaseAddress.push(addressLineValue);
    }
  }

  /* Apply default settings for dealer address lines */
  if (dealerBaseAddress.length === 0) {

    for (let j = 0; j < defaultPlaceholders.length; j++) {
      const defaultAddressLineValue = renderTemplate(`${ defaultPlaceholders[j] }`, dealer, false).trim();
      if (defaultAddressLineValue) dealerBaseAddress.push(defaultAddressLineValue);
    }
  }
  return dealerBaseAddress;
}

export default class DealerBaseAddress extends Component<$Props> {

  render() {
    const { widgetState } = this.props;
    const { dealer, configuration, settings } = widgetState;

    const defaultPlaceholders = [
      Globals.DEFAULT_DEALER_ADDRESS_PLACEHOLDER_LINE_1,
      Globals.DEFAULT_DEALER_ADDRESS_PLACEHOLDER_LINE_2
    ];

    const dealerBaseAddress: Array<string> =
      getDealerBaseAddress(dealer || {}, configuration || {}, settings.market || '', defaultPlaceholders);

    return (
      <div className="dl-dealer-base-address">
        { dealerBaseAddress.map((addressLine: string, idx: number) => (
          <p key={ idx }
          className={ `dl-dealer-address-line dl-dealer-address-line-${ ++idx } ` +
          `${ this.props.addressLineModifierClass || ''}`}>
            { addressLine }
          </p>
        ))}
      </div>
    );
  }
}
